import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import { store } from '@/store';
import RemoveFromBasketWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.RemoveFromBasketWebRequest;
import { BasketType } from '@/enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'MiniBasketItemB2B',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {item: LineItemViewObject}



const isMiniBasketOpen = computed<boolean>(() => store.getters['navigation/isMiniBasketOpen']);
const isMiniQuoteBasketOpen = computed<boolean>(() => store.getters['navigation/isMiniQuoteBasketOpen']);


const showErrorImage = ref<boolean>(false);
const showSpinner = ref<boolean>(true);
const showDetails = ref<boolean>(false);

function imageSuccess() {
    showErrorImage.value = false;
    showSpinner.value = false;
}

function imageError() {
    showErrorImage.value = true;
    showSpinner.value = false;
}
function removeFromBasket(request: RemoveFromBasketWebRequest) {
    store.dispatch('basket/removeFromBasket', request);
}

function removeFromQuoteBasket(request: RemoveFromBasketWebRequest) {
    store.dispatch('quotebasket/removeFromBasket', request);
}

function onRemoveFromBasketClick() {
    if (isMiniBasketOpen.value) {
        removeFromBasket({ id: props.item.lineItemId, basketType: BasketType.B2B as any });
    } else {
        removeFromQuoteBasket({ id: props.item.lineItemId, basketType: BasketType.Quotation as any });
    }
}

return { __sfc: true,props, isMiniBasketOpen, isMiniQuoteBasketOpen, showErrorImage, showSpinner, showDetails, imageSuccess, imageError, removeFromBasket, removeFromQuoteBasket, onRemoveFromBasketClick }
}

})